import React, { forwardRef } from "react";
import { Text, Box, RadioCards, Flex, Button } from "@radix-ui/themes";

const Pricing = forwardRef((props, ref) => {
  return (
    <div
      ref={ref}
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "80vh",
      }}
    >
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          paddingTop: "125px",
        }}
      >
        <Flex
          display="flex"
          direction="column"
          align="center"
          justify="center"
          gap="6"
          style={{
            textAlign: "center",
            paddingTop: "60px",
            paddingBottom: "55px",
          }}
        >
          <div>
            <Text
              size="9"
              weight="bold"
              style={{
                maxWidth: "50%",
              }}
            >
              Pay As You Go
            </Text>
          </div>

          <div>
            <Text
              weight="light"
              color="white"
              style={{
                maxWidth: "60%",
              }}
            >
              Start with 10 free tokens, allowing you to create 10 audios.
            </Text>
          </div>
        </Flex>

        <Box>
          <RadioCards.Root
            defaultValue="0"
            color="green"
            columns={{ initial: "0", sm: "4" }}
          >
            <RadioCards.Item
              value="0"
              style={{
                backgroundColor: "black",
                "--radio-cards-item-background-color": "black",
              }}
            >
              <Flex direction="column" gap="3" width="100%" align="center">
                <Text
                  weight="bold"
                  color="green"
                  size="9"
                  style={{ color: "#009951" }}
                >
                  Free
                </Text>
                <Text color="orange" size="3">
                  Start with 10 free Tokens
                </Text>
              </Flex>
            </RadioCards.Item>
            <RadioCards.Item
              value="0"
              style={{
                backgroundColor: "black",
                "--radio-cards-item-background-color": "black",
              }}
            >
              <Flex direction="column" gap="3" width="100%" align="center">
                <Text
                  weight="bold"
                  color="green"
                  size="9"
                  style={{ color: "#009951" }}
                >
                  $1
                </Text>
                <Text color="orange" size="3">
                  10 Tokens
                </Text>
              </Flex>
            </RadioCards.Item>
            <RadioCards.Item
              value="0"
              style={{
                backgroundColor: "black",
                "--radio-cards-item-background-color": "black",
              }}
            >
              <Flex direction="column" gap="3" width="100%" align="center">
                <Text
                  weight="bold"
                  color="green"
                  size="9"
                  style={{ color: "#009951" }}
                >
                  $3
                </Text>
                <Text color="orange" size="3">
                  35 Tokens
                </Text>
              </Flex>
            </RadioCards.Item>
            <RadioCards.Item
              value="0"
              style={{
                backgroundColor: "black",
                "--radio-cards-item-background-color": "black",
              }}
            >
              <Flex direction="column" gap="3" width="100%" align="center">
                <Text weight="bold" style={{ color: "#009951" }} size="9">
                  $5
                </Text>
                <Text color="orange" size="3">
                  50 Tokens
                </Text>
              </Flex>
            </RadioCards.Item>
          </RadioCards.Root>
        </Box>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "60px",
          }}
        >
          <Flex
            display="flex"
            direction="column"
            align="center"
            justify="center"
            gap="6"
            style={{
              textAlign: "center",
            }}
          >
            <div>
              <Text
                size="7"
                weight="medium"
                style={{
                  maxWidth: "50%",
                }}
              >
                Try Tellos for free now
              </Text>
              <br />
            </div>

            <Button
              size="4"
              variant="solid"
              style={{ cursor: "pointer", backgroundColor: "#009951" }}
              onClick={() =>
                (window.location.href = "http://app.iamtellos.com")
              }
            >
              <Text>Start learning</Text>—<Text weight="light">for free</Text>
            </Button>
          </Flex>
        </div>
      </div>
    </div>
  );
});

export default Pricing;
